import * as XLSX from "xlsx";

// Reads the spreadsheet Apple Business Manager gives you when you buy custom
// app codes (.xls; .xlsx and .csv work too): a few label rows (Order ID,
// Product, Codes Purchased, …), then a "Code" / "Code Redemption Link"
// table.

const REDEEM_LINK = /^https:\/\/apps\.apple\.com\/redeem\?code=([A-Z0-9]+)/i;
const CODE = /^[A-Z0-9]{6,32}$/i;

/** Rows (arrays of cells) → { orderId, product, codes: [{ code, link }] }. */
export const parseCodeRows = (rows) => {
  const sheet = { orderId: "", product: "" };
  const codes = new Map();
  let inCodeTable = false;

  for (const row of rows) {
    const cells = (row || []).map((cell) => String(cell ?? "").trim());
    const label = (cells[0] || "").toLowerCase();
    const valueAfterLabel = cells.slice(1).find(Boolean) || "";

    if (label === "order id") sheet.orderId = valueAfterLabel;
    else if (label === "product") sheet.product = valueAfterLabel;
    else if (label === "code") {
      inCodeTable = true;
      continue;
    }

    const link = cells.find((cell) => REDEEM_LINK.test(cell));
    if (link) {
      const code = REDEEM_LINK.exec(link)[1].toUpperCase();
      codes.set(code, { code, link });
    } else if (inCodeTable && CODE.test(cells[0] || "")) {
      // A code with no link column — the server builds the link.
      const code = cells[0].toUpperCase();
      codes.set(code, { code, link: "" });
    }
  }

  return { ...sheet, codes: [...codes.values()] };
};

/** A File from an <input type="file"> → the parsed sheet. */
export const readCodeSheet = async (file) => {
  const workbook = XLSX.read(await file.arrayBuffer());
  const rows = workbook.SheetNames.flatMap((name) =>
    XLSX.utils.sheet_to_json(workbook.Sheets[name], { header: 1, raw: false, defval: "" })
  );
  return parseCodeRows(rows);
};
